import { useState } from "react";
import { Box } from "@oneloop/jopijs";
import ImagePicker from "../PickerWithInput/ImagePicker";
import LinkPicker from "../PickerWithInput/LinkPicker";
import DynamicTagsPicker from "../DynamicTagsPicker";
import DynamicTags from "../DynamicTags";
import {
  BoldButton,
  ItalicButton,
  UnderlineButton,
  FontSizeButton,
  ColorButton,
  LineHeightButton,
  UnorderedListButton,
  OrderedListButton,
  AlignmentButton,
  LinkButton,
} from "../buttons";
import styles from "./styles.module.scss";

/**
 *
 * @param {Object} props
 * @param {Object} [props.editor] - Editor instance from wysiwyg lib. If is not provided, the component would render null
 *
 * @returns {JSX.Element}
 *
 * @example
 * <Toolbar />
 * <Toolbar editor={editor} />
 */
function Toolbar({ editor }) {
  return (
    <Box className={styles["toolbar-container"]}>
      <Box className={styles["left-side"]}>
        <Box className={styles["buttons-group"]}>
          <BoldButton editor={editor} />
          <ItalicButton editor={editor} />
          <UnderlineButton editor={editor} />
          <FontSizeButton editor={editor} />
        </Box>
        <Box className={styles["buttons-group"]}>
          <LineHeightButton editor={editor} position="single" />
        </Box>
      </Box>
    </Box>
  );
}

export default Toolbar;
